module.exports = __webpack_public_path__ + "img/1f9be.79d0eac.svg";